var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-question mt-1 mb-lg-5"},[(_vm.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }